import { useState } from "react";

export const useCopyHandler = (value: string) => {
  const [copied, setCopied] = useState<boolean>(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error("Fehler beim Kopieren:", error);
    }
  };

  return { copied, handleCopy };
};